import React from "react";

export default function CaseHearingTable({ cases, onEdit, onDelete }) {
  return (
    <div className="table-responsive mt-4">
      <table className="table table-striped">
        <thead className="table-dark">
          <tr>
            <th>ID</th>
            <th>Case Number</th>
            <th>Type</th>
            <th>Versus</th>
            <th>Hearing Date</th>
            <th>Next Hearing</th>
            <th>Status</th>
            <th>Remarks</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {cases.length > 0 ? (
            cases.map((c) => (
              <tr key={c.id}>
                <td>{c.id}</td>
                <td>{c.caseNumber}</td>
                <td>{c.caseType}</td>
                <td>{c.versus}</td>
                <td>{new Date(c.hearingDate).toLocaleDateString()}</td>
                <td>{new Date(c.nextHearingDate).toLocaleDateString()}</td>
                <td>{c.status}</td>
                <td>{c.remarks}</td>
                <td>
                  <button
                    className="btn btn-sm btn-warning me-2"
                    onClick={() => onEdit(c)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onDelete(c.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="9" className="text-center">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
